// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"4976":"83b814a61a93a5de","9946":"727973242bb33abd"}[chunkId] + ".css";
};